import CopyrightInfo from './CopyrightInfo';

export default CopyrightInfo;
